import { Box, Typography } from '@mui/material';
import React from 'react';
import logoAlertAiEducation from '../../../../assets/images/favicon.png';
import walpaperAdventista from '../../../assets/adventista.jpg';
import imagem1 from '../../../../assets/images/proposalImagens/childrenImage.jpeg';
import imagem2 from '../../../../assets/images/proposalImagens/recognitialImage.jpeg';

interface PdfViewerProps {
  formData: { image1?: File | null; image2?: File | null };
  formaDataContext?: { logos?: (File | null)[] };
  boxRef: React.Ref<unknown>;
}

const PdfViewerSecond: React.FC<PdfViewerProps> = ({
  formData,
  boxRef,
  formaDataContext,
}) => {
  return (
    <Box
      sx={{
        width: '95vw',
        height: '90vh',
        maxWidth: 'calc(93vh * 0.700)',
        aspectRatio: '1 / 1.414',
        backgroundColor: 'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: 'auto',
        position: 'relative',
      }}
      ref={boxRef}
    >
      <Box
        sx={{
          height: '100%',
          width: '7vh',
          backgroundColor: '#224FA2',
        }}
      />

      <div style={{ width: '100%' }}>
        <Typography
          sx={{
            fontSize: '2.5rem',
            width: '55%',
            fontWeight: 'bold',
            color: '#224FA2',
            marginBottom: '1rem',
            lineHeight: 1,
            paddingLeft: '24px',
          }}
        >
          Resumo do projeto
        </Typography>
        <Box
          sx={{
            width: '40%',
            height: '5px',
            marginLeft: '24px',
            marginBottom: '2rem',
            backgroundColor: '#54B55D',
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '20vh',
            marginBottom: '1rem',
          }}
        >
          <img
            src={
              formData.image1 ? URL.createObjectURL(formData.image1) : imagem1
            }
            alt="Painel ilustrativo"
            style={{
              width: '23vh',
              height: 'auto',
            }}
          />
          <Typography
            sx={{
              fontSize: '0.8rem',
              width: '65%',
              px: '24px',
              fontWeight: 'bold',
              color: '#224FA2',
              lineHeight: 1,
              paddingLeft: '15px',
            }}
          >
            Essa tecnologia oferece uma camada extra de segurança e
            tranquilidade, permitindo que os pais se sintam mais confiantes e
            seguros sobre o bem-estar de seus filhos{' '}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '20vh',
            marginBottom: '1rem',
          }}
        >
          <img
            src={
              formData.image2 ? URL.createObjectURL(formData.image2) : imagem2
            }
            alt="Painel ilustrativo"
            style={{
              width: '23vh',
              height: 'auto',
            }}
          />
          <Typography
            sx={{
              fontSize: '0.8rem',
              width: '65%',
              px: '24px',
              fontWeight: 'bold',
              color: '#224FA2',
              lineHeight: 1,
              paddingLeft: '15px',
            }}
          >
            O Alert Ai Education proporciona segurança avançada para escolas,
            universidades e creches, e tranquilidade para os pais, garantindo
            que os filhos cheguem em segurança ao seu destino.
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            width: '100%',
            mt: '2rem',
            height: '6vh',
            paddingLeft: '24px',
          }}
        >
          {(formaDataContext?.logos ?? [])
            .filter((logo): logo is File => logo instanceof File)
            .map((logo, index) => (
              <img
                key={index}
                src={URL.createObjectURL(logo)}
                alt={`Logo ${index + 1}`}
                style={{
                  height: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            ))}

          <img
            src={logoAlertAiEducation}
            alt="Logo AlertAi"
            style={{
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
      </div>
    </Box>
  );
};

export default PdfViewerSecond;
